const clickTimeLimit: number = 200;
let mouseDownMoment: number = 0;

export const markMoment = (): void => {
  mouseDownMoment = Date.now();
};

export const distinguishClick = (): boolean => {
  return Date.now() - mouseDownMoment < clickTimeLimit;
};
